import axios from "axios";

const baseApi = `${process.env.REACT_APP_API_ROOT}` + "/api";

// Utility function for creating headers
const getHeaders = (token) => ({
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: `Bearer ${token}`,
  },
});

// Function to add a new score
export const addNewScore = (formData, token) => {
  return axios.post(`${baseApi}/add_new_score/`, formData, getHeaders(token));
};

// Function to add scores in bulk
export const addNewScoreBulk = (formData, token) => {
  return axios.post(`${baseApi}/add_new_score_bulk/`, formData, getHeaders(token));
};



